var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'ordenes')?_c('view-component',{attrs:{"model_name":"order_production","order_list_by":"order_production_status","show_filter_modal":""},on:{"modelSaved":_vm.modelSaved},scopedSlots:_vm._u([{key:"modal_buttons",fn:function(data){return [_c('modal-buttons')]}}],null,false,2036216006)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }